import { AsyncPipe } from '@angular/common';
import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { NgbDropdown, NgbTooltip, NgbDropdownToggle, NgbDropdownMenu } from '@ng-bootstrap/ng-bootstrap';
import { HotkeysService } from 'angular2-hotkeys';
import { Memoize } from 'lodash-decorators';

import { DeviceService } from '@app/services/device.service';
import { GlobalService } from '@app/services/global.service';
import { ModalService } from '@app/services/modal.service';
import { DeviceGraphicComponent } from '@app/shared/device-graphic/device-graphic.component';
import { DeviceStateClassPipe } from '@app/shared/device-state-class.pipe';
import { DeviceStateMessagePipe } from '@app/shared/device-state-message.pipe';
import { TruncatePipe } from '@app/shared/truncate.pipe';
import { Device, deviceMemoizeResolver } from '@app/store/device.model';

@Component({
  selector: 'app-device-list-dropdown',
  styleUrls: ['./device-list-dropdown.component.scss'],
  templateUrl: './device-list-dropdown.component.html',
  imports: [
    NgbDropdown,
    NgbTooltip,
    NgbDropdownToggle,
    NgbDropdownMenu,
    DeviceGraphicComponent,
    AsyncPipe,
    DeviceStateClassPipe,
    DeviceStateMessagePipe,
    TruncatePipe,
  ],
})
export class DeviceListDropdownComponent {
  private deviceService = inject(DeviceService);
  private hotkeysService = inject(HotkeysService);
  private modalService = inject(ModalService);
  private globalService = inject(GlobalService);

  @Input() device: Device;

  @Output() selectDevice = new EventEmitter<Device>();
  @Output() backToDashboard = new EventEmitter<void>();

  allDevices$ = this.deviceService.allDevices$;

  @Memoize(deviceMemoizeResolver)
  deviceCurrentState(device: Device) {
    return this.deviceService.selectDeviceCurrentState(device);
  }

  @Memoize(deviceMemoizeResolver)
  deviceName(device: Device) {
    return this.deviceService.selectDeviceName(device);
  }

  onViewDeviceLog(device: Device) {
    this.modalService.openDeviceLogViewerModal(device);
  }

  onViewSystemLog() {
    this.modalService.openSystemLogViewerModal();
  }

  onSaveProblemReport() {
    this.globalService.requestSaveProblemReport();
  }

  onKeyboardShortcuts() {
    this.hotkeysService.cheatSheetToggle.next(undefined);
  }
}
